import { create } from 'zustand';
import { isLooseEqual } from '@app/utils/equality';

// SERVICE

const initialData = {
  lastFilterData: null, // 필터 데이터 --> page가 0 일 때 저장된 filter
  pagination: { totalCount: 0, currentPage: 0, totalPage: 0, pageSize: 20 }, // 페이징 처리
  sort: 'update', // 정렬
  inquiryList: null, // 객실 문의 리스트
  collapsed: false, // 필터 메뉴 접기
  scrollState: null, // 스크롤 상태
  invoiceCheckbox: false, // 인보이스 체크박스
  isSendConfirmReq: false, // 긴급 미컨펌 체크박스
};

const MobileInquiryPageStore = create((set, get) => ({
  ...initialData,

  // 각 필터 데이터 set
  setData: (filterType, params) => {
    const isSame = isLooseEqual(JSON.stringify(params), JSON.stringify(get()[filterType]));
    !isSame && set({ [filterType]: params });
  },

  // 단순 데이터 set
  setInquiryStoreState: (key, value) => set({ [key]: value }),

  // push로 들어올 때 초기 세팅
  setInquiryInitFromPush: async (info) => {},
  getStoreData: (type) => {
    return get()[type];
  },

  // 채팅 버튼 클릭 시 해당 id의 chatStatus.isCheck를 flase 로 변경
  fetchReadChatInquiryList: (inquiryId) => {
    const newList = get()?.inquiryList?.map((inquiry) => {
      if (inquiry?.chatStatus?.reservationId)
        return {
          ...inquiry,
          chatStatus: {
            reservationId: inquiry.id,
            isCheck:
              isLooseEqual(inquiryId, inquiry.id) ? true : inquiry.chatStatus.isCheck,
          },
        };
      else return inquiry;
    });
    set({ inquiryList: newList });
  },

  // 스토어 리셋
  resetInquiryStore: () => set({ ...initialData }),
}));
export default MobileInquiryPageStore;
